import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import { getShowChangeOrderQuoteModal } from 'components/admin/work-orders/details/change-order-quotes/store/selectors';
import {
  setShowChangeOrderQuoteModal,
  submitChangeOrderQuote,
} from 'components/admin/work-orders/details/change-order-quotes/store/actions';
import ChangeOrderQuoteSubmitForm from 'components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteSubmitForm';
import numeral from 'numeral';

class ChangeOrderQuoteSubmitModal extends Component {
  handleClose = () => {
    this.props.dispatch(setShowChangeOrderQuoteModal());
  };

  handleOnSubmit = (values) => {
    values.id = this.props.changeOrderTask.change_order_quote.id;
    this.props.dispatch(
      submitChangeOrderQuote(this.props.changeOrderTask.id, values)
    );
  };

  render() {
    const coQuote = this.props.changeOrderTask.change_order_quote;
    if (coQuote.status === 'withdrawn') {
      this.initialValues = {
        startDate: coQuote.start_date,
        daysOfDuration: numeral(coQuote.days_of_duration).value(),
        materialLeadDays: numeral(coQuote.material_lead_days).value(),
        estimate: coQuote.estimate,
        description: coQuote.description,
      };
    }

    return (
      <div>
        <FormModal
          className="change-order-quote-request-modal"
          show={this.props.show}
          title="Change Order Pricing"
          onClose={this.handleClose}
        >
          <ChangeOrderQuoteSubmitForm
            changeOrderTask={this.props.changeOrderTask}
            initialValues={this.initialValues}
            onSubmit={this.handleOnSubmit}
          />
        </FormModal>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    show: getShowChangeOrderQuoteModal(state),
  };
})(ChangeOrderQuoteSubmitModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteSubmitModal.js